module.exports = __webpack_public_path__ + "img/Dental.158d8e3.png";